export interface Task {
  type: string
  id?: string
  attributes: {
    due_date: number
    start_date?: number
    description: string
    ticket_number?: string
    status: string
    user_assignee_id: number
    user_assignee_reference: string
    user_creator_reference?: string
  }
  relationships: {
    deal?: {
      id: string
      type: string
    }
    user_assignee: {
      id: number
      type: string
    }
    deal_stage: {
      id: string
      type: string
    }
  }
}

export const taskAttributes = [
  "due_date",
  "start_date",
  "description",
  "ticket_number",
  "deal_stage",
  "status",
  "user_assignee_id",
  "user_assignee_reference",
  "user_creator_reference"
]
